module.exports = __webpack_public_path__ + "img/eyebrow_male_arched_average_mask.f7d015fe.png";